import React from 'react';
import './MagazineStageSimple.css';
import { useTranslation } from 'react-i18next';

const MagazineStageSimple = ({
  imageSrc,
  imageAlt,
  meta,
  title,
  text,
  tags = [],
  readingTimeMinutes,
}) => {
  const { t } = useTranslation();

  return (
    <div className="c-magazine-stage-simple" data-media-focus-point="top-center">
      <div className="c-magazine-stage-simple__media">
        <picture>
          <img
            src={imageSrc}
            alt={imageAlt ? t(imageAlt) : ''}
            sizes="100vw"
            className="c-magazine-stage-simple__image"
          />
        </picture>
      </div>

      <div className="c-magazine-stage-simple__body">
        <div className="c-magazine-stage-simple__content-wrapper">
          {meta && (
            <span className="c-magazine-stage-simple__meta-data">
              {t(meta)}
            </span>
          )}

          {title && (
            <h1 className="c-magazine-stage-simple__title">
              {t(title)}
            </h1>
          )}

          {text && (
            <p className="c-magazine-stage-simple__text">
              {t(text)}
            </p>
          )}

          {Array.isArray(tags) && tags.length > 0 && (
            <div className="c-magazine-stage-simple__tag-list">
              <ul className="c-tag-list">
                {tags.map((tag) => (
                  <li className="c-tag-list__item" key={tag?.href || tag?.label}>
                    {tag?.href ? (
                      <a className="c-tag c-tag--secondary" href={tag.href}>
                        {t(tag.label)}
                      </a>
                    ) : (
                      <span className="c-tag c-tag--secondary">
                        {t(tag?.label)}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {typeof readingTimeMinutes === 'number' && !Number.isNaN(readingTimeMinutes) && (
            <span className="c-magazine-stage-simple__reading-time">
              <span className="c-magazine-stage-simple__reading-time-icon" aria-hidden="true">i</span>
              {t('Est. reading time is')} {readingTimeMinutes} {t('minutes')}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MagazineStageSimple;
